import FetchService from "./Shared/FetchService";
import NoteDomainService from "../Domain/Note/Note.service";
const BASE_URL = "/aviso/note";
export default class NoteService {
    static createNoteFromMessage(affiliationId, noteTypes, text, sourceId) {
        return FetchService.post("/aviso/advisor/createNoteFromMessage", {
            affiliationId,
            noteTypes,
            text,
            sourceId,
        });
    }
    static createNoteWithText(studentAffiliationId, noteTypes, text, sourceId = "") {
        return FetchService.postSingleResponse("/aviso/advisor/createNoteWithText", {
            note: {
                affiliationId: studentAffiliationId,
                noteTypes,
                text,
                sourceId,
            },
        });
    }
    static createNoteWithTextForPersonPopulation(populationId, noteTypeIds, text, sourceId = "") {
        return FetchService.postSingleResponse("/aviso/note/createNoteWithTextForPersonPopulation", {
            populationId,
            noteTypeIds,
            text,
            sourceId,
        });
    }
    static updateNoteWithText(params) {
        return FetchService.post("/aviso/advisor/updateNoteWithText", {
            note: {
                id: params.noteId,
                noteTypes: params.noteTypes,
                text: params.text,
                sourceId: params.sourceId || "",
            },
            // @ts-expect-error - TS2345 - Argument of type '(json: { [key: string]: any; }) => Note' is not assignable to parameter of type '(value: unknown) => Note | PromiseLike<Note>'.
        }).then(NoteDomainService.fromJSON);
    }
    static getNotesOnPersonAlert(personAlertId) {
        return FetchService.getSingleResponse("/aviso/advisor/getNotesForPersonAlert", { alertId: personAlertId });
    }
    static getNotesForPerson(affiliationId, options = {}) {
        return FetchService.getPagedResponse("/aviso/advisor/getNotes", {
            affiliationId,
            max: options.max || 20,
            offset: options.offset || 0,
        }).then((resp) => (Object.assign(Object.assign({}, resp), { 
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            data: resp.data && resp.data.map(NoteDomainService.fromJSON) })));
    }
    static deleteNote(noteId) {
        return FetchService.deleteSingleResponse("/aviso/advisor/deleteNote", {
            noteId,
        });
    }
    static getNote(noteId) {
        return FetchService.getSingleResponse("/aviso/advisor/getNote", {
            noteId,
            // @ts-expect-error - TS2345 - Argument of type '(json: { [key: string]: any; }) => Note' is not assignable to parameter of type '(value: unknown) => Note | PromiseLike<Note>'.
        }).then(NoteDomainService.fromJSON);
    }
    static canIEdit(noteIds) {
        return FetchService.getSingleResponse("/aviso/note/canIEdit", { noteIds });
    }
    static saveForOpportunity({ opportunityId, noteTypeIds, text, }) {
        return NoteService.saveForOpportunities({
            opportunityIds: [opportunityId],
            noteTypeIds,
            text,
        });
    }
    static saveForOpportunities({ opportunityIds, pipelineId, noteTypeIds, text, }) {
        return FetchService.postSingleResponse(BASE_URL + "/saveForOpportunities", {
            opportunityIds,
            pipelineId,
            noteTypeIds,
            text,
        });
    }
}
